module.exports = __webpack_public_path__ + "media/components/Sponsors/FormTags/Categories/33-5fd3462225346286151fa10d2335dcbe.png";